import React from 'react';
import {  useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { formChangedAction } from '../../../actions/index';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import EnlargableTextbox from 'components/common/EnlargableTextbox';
import { emailSettingDataDetailAction } from 'actions/SystemSettings/systemSettingsAction';

export const EmailSettingsDetails = () => {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const systemSettingReducer = useSelector(
    state => state.rootReducer.systemSettingReducer
  );
  var emailSettingData = systemSettingReducer.emailSettingData;

  const emailSettingErrorReducer = useSelector(
    state => state.rootReducer.emailSettingErrorReducer
  );
  const emailSettingErr = emailSettingErrorReducer.emailSettingDetailsError;

  const formChangedReducer = useSelector(
    state => state.rootReducer.formChangedReducer
  );
  var formChangedData = formChangedReducer.formChanged;

  const handleFieldChange = e => {
    dispatch(
      emailSettingDataDetailAction({
        ...emailSettingData,
        [e.target.name]: e.target.value,
        IsEmailSettingModule: true,
      })
    );

    if (emailSettingData.encryptedEmailSettingId) {
      dispatch(
        formChangedAction({
          ...formChangedData,
          EmailSettingUpdate: true
        })
      );
    }
  };

  return (
    <>

      {emailSettingData && (
        <>
          <Form
            noValidate
            className="details-form job-module-card"
            id="addSchedulerDetail"
          >
            <Row>
              <Col className="me-3 ms-3">
                <Row className="mb-3">
                  <Form.Label>
                    Email Title<span className="text-danger">*</span>
                  </Form.Label>
                  <EnlargableTextbox
                    id="txtEmailTitle"
                    name="emailTitle"
                    maxLength={50}
                    value={emailSettingData.emailTitle}
                    onChange={handleFieldChange}
                    placeholder="Email Title"
                    required={true}
                  />
                  {Object.keys(emailSettingErr.emailTitleErr).map(key => {
                    return (
                      <span className="error-message">
                        {emailSettingErr.emailTitleErr[key]}
                      </span>
                    );
                  })}
                </Row>
                <Row className="mb-3">
                  <Form.Label>
                    BCC Email
                  </Form.Label>
                  <EnlargableTextbox
                    id="txtFormEmail"
                    name="bccEmail"
                    placeholder="BCC Email"
                    value={emailSettingData?.bccEmail}
                    onChange={handleFieldChange}
                    required
                  />
                  {Object.keys(emailSettingErr.bccEmailErr).map(key => {
                    return (
                      <span className="error-message">
                        {emailSettingErr.bccEmailErr[key]}
                      </span>
                    );
                  })}
                </Row>
                <Row className="mb-3">
                  <Form.Label>
                    Provider
                  </Form.Label>
                  <EnlargableTextbox
                    id="txtProvider"
                    name="provider"
                    placeholder="Provider"

                    value={emailSettingData?.provider ? emailSettingData?.provider : ""}
                    onChange={handleFieldChange}
                    required
                  />

                  {/* {Object.keys(emailSettingErr.weekDayErr).map(key => {
                    return (
                      <span className="error-message">
                        {emailSettingErr.weekDayErr[key]}
                      </span>
                    );
                  })} */}
                </Row>
              </Col>
              <Col className="me-3 ms-3">
                <Row className="mb-3">
                  <Form.Label>
                    From Email<span className="text-danger">*</span>
                  </Form.Label>
                  <EnlargableTextbox
                    id="txtFormEmail"
                    name="fromEmail"
                    placeholder="From Email"
                    value={emailSettingData.fromEmail}
                    onChange={handleFieldChange}
                    required
                  />

                  {Object.keys(emailSettingErr.fromEmailErr).map(key => {
                    return (
                      <span className="error-message">
                        {emailSettingErr.fromEmailErr[key]}
                      </span>
                    );
                  })}
                </Row>
                <Row className="mb-3">
                  <Form.Label>
                    Port<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    id="txtPort"
                    name="port"
                    placeholder='Port'
                    value={emailSettingData.port}
                    onChange={handleFieldChange}
                  />
                  {Object.keys(emailSettingErr.portErr).map(key => {
                    return (
                      <span className="error-message">
                        {emailSettingErr.portErr[key]}
                      </span>
                    );
                  })}
                </Row>
              </Col>
              <Col className="me-3 ms-3">
                <Row className="mb-3">
                  <Form.Label>
                    From Email Password<span className="text-danger">*</span>
                  </Form.Label>
                  <div style={{ position: 'relative', width: '100%', padding: '0px' }}>
                    <Form.Control
                      id="txtFromEmailPassword"
                      name="emailPassword"
                      type={showPassword ? 'text' : 'password'}
                      placeholder="From Email Password"
                      value={emailSettingData.emailPassword || ""}
                      onChange={handleFieldChange}
                    />
                    {emailSettingData.emailPassword && (
                      <span
                        onClick={() => setShowPassword(prev => !prev)}
                        style={{
                          position: 'absolute',
                          top: '50%',
                          right: '10px',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer'
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    )}
                  </div>
                  {Object.keys(emailSettingErr.fromEmailPasswordErr).map((key, index) => (
                    <span className="error-message d-block text-danger" key={index}>
                      {emailSettingErr.fromEmailPasswordErr[key]}
                    </span>
                  ))}
                </Row>

                <Row className="mb-3">
                  <Form.Label>Host<span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    id="txtHost"
                    name="host"
                    placeholder='Host'
                    value={emailSettingData.host}
                    onChange={handleFieldChange}
                  />
                  {Object.keys(emailSettingErr.hostErr).map(key => {
                    return (
                      <span className="error-message">
                        {emailSettingErr.hostErr[key]}
                      </span>
                    );
                  })}
                </Row>
              </Col>
            </Row>
          </Form>
        </>
      )}
    </>
  );
};

export default EmailSettingsDetails;
